'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'
import React, { useMemo, useState } from 'react'

import ZTeamMemberCard from '@/_components/custom/universal/team-member-card/z-team-member-card'
import { IEmployee, IEmployeeReduced } from '@/_types'

const ASectionAssignedEmployeesListShowMoreButtons = ({
	showMore,
	setShowMore
}: {
	showMore: boolean
	setShowMore: (showMore: boolean) => void
}) => {
	const t = useTranslations('components.sections.employees')

	const handleShowLess = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		setShowMore(false)
	}

	const handleShowMore = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		setShowMore(true)
	}

	return (
		<>
			<div className='dflex justify-center mgb-10md mgb-20'>
				{showMore ? (
					<Link
						href='#'
						title=''
						className='btn_basic type7 up'
						onClick={handleShowLess}
						prefetch={false}
					>
						<span>{t('showLess')}</span>
						<span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar1_u'></use>
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar1_u'></use>
								</svg>
							</span>
						</span>
					</Link>
				) : (
					<Link
						href='#'
						title=''
						className='btn_basic type7 up'
						onClick={handleShowMore}
						prefetch={false}
					>
						<span>{t('showMore')}</span>
						<span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar1_d'></use>
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use href='/assets/layout/icons.svg#s_ar1_d'></use>
								</svg>
							</span>
						</span>
					</Link>
				)}
			</div>
		</>
	)
}

const ASectionAssignedEmployeesList = ({
	employees,
	initialEmployeesCount = 4,
	orderUrl
}: {
	employees: IEmployee[] | IEmployeeReduced[]
	initialEmployeesCount?: number
	orderUrl?: string
}) => {
	const [showMore, setShowMore] = useState(false)

	const allEmployees = useMemo(() => {
		if (!employees || !Array.isArray(employees)) {
			return []
		}

		return employees.sort((a, b) => {
			const sortOrderA =
				a?.categories?.sort((a, b) => a.sortOrder ?? 0 - (b.sortOrder ?? 0))[0]
					?.sortOrder ?? 0
			const sortOrderB =
				b?.categories?.sort((a, b) => a.sortOrder ?? 0 - (b.sortOrder ?? 0))[0]
					?.sortOrder ?? 0

			return sortOrderA - sortOrderB
		})
	}, [employees])

	const employeesToShow = useMemo(() => {
		if (!showMore) {
			return allEmployees.slice(0, initialEmployeesCount)
		}
		return allEmployees
	}, [allEmployees, showMore, initialEmployeesCount])

	if (allEmployees.length === 0) {
		return null
	}

	return (
		<>
			<div className='box_team mgt-70lg mgt-70 mgb-0lg mgb-60 mgl-0lg mgl-120'>
				{employeesToShow.map(employee => (
					<ZTeamMemberCard
						key={employee.id}
						employee={employee}
						reservationButton={true}
						orderUrl={orderUrl}
					/>
				))}
			</div>

			{allEmployees.length > initialEmployeesCount && (
				<ASectionAssignedEmployeesListShowMoreButtons
					showMore={showMore}
					setShowMore={setShowMore}
				/>
			)}
		</>
	)
}

export default ASectionAssignedEmployeesList
